const en = {
    allAdsInCategory: "All ads in category",
    totalAds: "Total ads",
    noAdsInCategoryPart1: "No ads added in category",
    noAdsInCategoryPart2: ":(",
    backBtn: "Back",
    upBtn: "Up",
  };
  
  const rus = {
    allAdsInCategory: "Все объявления в категории",
    totalAds: "Количество объявлений",
    noAdsInCategoryPart1: "В категории ",
    noAdsInCategoryPart2: ", не добавлено ни одного объявления:(",
    backBtn: "Назад",
    upBtn: "Наверх",
  };
  
  const hebrew = {
    allAdsInCategory: "כל המודעות בקטגוריה",
    totalAds: "מספר מודעות",
    noAdsInCategoryPart1: "לא נוספו מודעות בקטגוריה",
    noAdsInCategoryPart2: ":(",
    backBtn: "חזרה",
    upBtn: "למעלה",
  };
  
  const choose = { en, rus, hebrew };
  
  export default choose;